module.exports = __webpack_public_path__ + "static/media/rocket.ca5111d2.png";